import { HTTP_PROTOCOL_REGEX, URL_VALIDATION_ERROR } from './constant';

export const normalizeUrl = (value: string): string | null => {
  try {
    const trimmed = value.trim();

    if (!trimmed) return null;

    const normalized = HTTP_PROTOCOL_REGEX.test(trimmed) ? trimmed : null;

    if (!normalized) return URL_VALIDATION_ERROR.INVALID_URL;

    const url = new URL(normalized);

    if (!url.hostname) return URL_VALIDATION_ERROR.INVALID_URL;

    return url.href;
  } catch {
    return URL_VALIDATION_ERROR.INVALID_URL;
  }
};
